import React from 'react';
import NormalTd from '../NormalTd';
import is from 'is_js';
import PropTypes from 'prop-types';

const TextTd = (props) => {
  return <NormalTd>
    <p>{judgeValue(props.text)}</p>
  </NormalTd>;

  function judgeValue(text) {
    if (is.undefined(text) || text === '') {
      return '-';
    }
    return text;
  }
};

TextTd.propTypes = {
  text: PropTypes.string,
};

export default TextTd;



// WEBPACK FOOTER //
// ./components/TableView/Tds/TextTd/index.jsx